import { OpportunityStageEnum } from '../api';
import i18next from 'i18next'; // Import the i18next instance

export const FORMAT_DATE = 'DD/MM/YYYY';
export const FORMAT_DATE_TIME = 'DD/MM/YYYY HH:mm';

export const OPPORTUNITY_SUPPORTED_FILE_TYPES = [
	'pdf',
	'doc',
	'docx',
	'ppt',
	'pptx',
];

export const OPPORTUNITY_STATES_DATA: {
	[key: string]: { label: string; cssClass: string; position: number };
} = {
	[OpportunityStageEnum.qualification]: {
		label: i18next.t('qualification'),
		cssClass: 'secondary',
		position: 1,
	},
	[OpportunityStageEnum.negotiation]: {
		label: i18next.t('negotiation'),
		cssClass: 'secondary',
		position: 2,
	},
	[OpportunityStageEnum.proposal]: {
		label: i18next.t('proposal'),
		cssClass: 'secondary',
		position: 3,
	},
	[OpportunityStageEnum.waiting_sign]: {
		label: i18next.t('waiting_sign'),
		cssClass: 'primary',
		position: 4,
	},
	[OpportunityStageEnum.credit_score_check]: {
		label: i18next.t('credit_score_check'),
		cssClass: 'primary',
		position: 5,
	},
	[OpportunityStageEnum.closed_won]: {
		label: i18next.t('closed_won'),
		cssClass: 'success',
		position: 6,
	},
	[OpportunityStageEnum.closed_by_credit_score_check]: {
		label: i18next.t('closed_by_credit_score_check'),
		cssClass: 'danger',
		position: 7,
	},
	[OpportunityStageEnum.closed_by_customer]: {
		label: i18next.t('closed_by_customer'),
		cssClass: 'danger',
		position: 8,
	},
	[OpportunityStageEnum.suspended]: {
		label: i18next.t('suspended'),
		cssClass: 'secondary',
		position: 9,
	},
};

export const NOLEGGIATORI = {
	ARVAL_PRIVATI: 'ARVAL PRIVATI',
	ARVAL_P_IVA: 'ARVAL P.IVA',
	LEASEPLAN: 'LEASEPLAN',
	ALD: 'ALD',
	LEASYS_I_CARE: 'LEASYS I-CARE',
	LEASYS_NOLEGGIO_CHIARO: 'LEASYS',
	ALPHABET: 'ALPHABET',
};

export const NOLEGGIATORI_QUOTATORE = {
	arval: {
		code: 'arval',
		name: 'Arval',
		noleggiatori_quicko: [NOLEGGIATORI.ARVAL_PRIVATI, NOLEGGIATORI.ARVAL_P_IVA],
	},
	leaseplan: {
		code: 'leaseplan',
		name: 'Leaseplan',
		noleggiatori_quicko: [NOLEGGIATORI.LEASEPLAN],
	},
	ald: {
		code: 'ald',
		name: 'ALD',
		noleggiatori_quicko: [NOLEGGIATORI.ALD],
	},
	leasys: {
		code: 'leasys',
		name: 'Leasys',
		noleggiatori_quicko: [
			NOLEGGIATORI.LEASYS_I_CARE,
			NOLEGGIATORI.LEASYS_NOLEGGIO_CHIARO,
		],
	},
	athlon: {
		code: 'athlon',
		name: 'Athlon',
		noleggiatori_quicko: [],
	},
	alphabet: {
		code: 'alphabet',
		name: 'Alphabet',
		noleggiatori_quicko: [NOLEGGIATORI.ALPHABET],
	},
	drivalia: {
		code: 'drivalia',
		name: 'Drivalia',
		noleggiatori_quicko: [],
	},
	rent2go: {
		code: 'rent2go',
		name: 'Rent2Go',
		noleggiatori_quicko: [],
	},
	vw_leasing: {
		code: 'vw_leasing',
		name: 'VW Leasing',
		noleggiatori_quicko: [],
	},
	kinto: {
		code: 'kinto',
		name: 'Kinto',
		noleggiatori_quicko: [],
	},
	unipol_rental: {
		code: 'unipol_rental',
		name: 'Unipol Rental',
		noleggiatori_quicko: [],
	},
	hyundai_rent: {
		code: 'hyundai_rent',
		name: 'Hyundai rent',
		noleggiatori_quicko: [],
	},
	ayvens: {
		code: 'ayvens',
		name: 'Ayvens',
		noleggiatori_quicko: [NOLEGGIATORI.ALD],
	},
};

export const horizonPointId = '40914';
export const LEADS_VIEW_LIMIT = 250;

export const STELLANTIS_MARCHE: string[] = [
    'ABARTH',
    'ALFA ROMEO',
    'CITROEN',
    'DS',
    'FIAT',
    'JEEP',
    'LANCIA',
    'MASERATI',
    'OPEL',
    'PEUGEOT',
    'CITROËN',
		'DODGE',
		'LEAPMOTOR',
];


export const OPPORTUNITY_SKIP_BACKOFFICE_USERS_INIT_FILTER = [
	'stefano.sepe@horizonautomotive.it',
	'daniele.allevi@horizonautomotive.it',
];


export const OPPORTUNITY_CREATION_LEAD_SOURCE = [
	'sito web',
	'form contatti sito web',
	'store',
	'dialogo',
	'contatto personale',
	'database dealer',
];

export const LEGACY_OPPORTUNITY_DATE = "2026-04-26T00:00:00.000+0000";
